import React, { Fragment, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CookieBanner from '../CookieBanner';
import { CookieConsent } from '@takeaway/ui-vanilla';
import { useCurrentUserActions } from '@src/shared/context/current-user';
import { useErrorScreenActions } from '@src/shared/context/error-screen';

export const RouterWrapper = ({ children }: any) => {
  const location = useLocation();
  const { setIsConsentBannerActive } = useCurrentUserActions();
  const { hideErrorScreen } = useErrorScreenActions();
  useEffect(() => {
    if (!CookieConsent.getConsent()) {
      setIsConsentBannerActive(true);
    }

    hideErrorScreen();
  }, [location.pathname]);

  const isNoConsentParameterExist = () => {
    return /[?&]no_consent=/.test(location.search);
  };

  return (
    <Fragment>
      <>
        {children}
        {!isNoConsentParameterExist() &&
        location.pathname !== '/cookie-statement' &&
        location.pathname !== '/courier-app-order-tutorial' &&
        location.pathname !== '/courier-app-bag-tutorial' ? (
          <CookieBanner />
        ) : null}
      </>
    </Fragment>
  );
};

export default RouterWrapper;
